import { FC } from 'react';
import { ActivityInput, Domain } from '../../../graphql/generated/graphql.ts';
import { useGetUsersDomainsQuery } from '../../../graphql/generated/operations/domain.ts';
import { LoadingBackdrop } from '../../../components/loading.backdrop.tsx';
import { Alert, Stack, Typography } from '@mui/material';
import { DomainListItem } from '../../../components/domain/domain-list-item.tsx';
import { useNeedToScheduleAChallengingActivityQuery } from '../../../graphql/generated/operations/activity.ts';

export interface DomainSelectionProps {
  onNext: (input: Partial<ActivityInput>, domain: Partial<Domain>) => void;
}

export const DomainSelection: FC<DomainSelectionProps> = ({ onNext }) => {
  const { data, loading } = useGetUsersDomainsQuery();
  const { data: needChallenging } = useNeedToScheduleAChallengingActivityQuery({
    variables: {
      offset: Math.floor(new Date().getTimezoneOffset() / 60) // Timezone offset in hours
    }
  });

  if (loading) {
    return <LoadingBackdrop />;
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Here are some activity suggestions based on your values.
      </Typography>
      {needChallenging?.needToScheduleAChallengingActivity && (
        <Alert severity="error" color="info" sx={(theme) => ({ mb: 2, borderWidth: 1, borderColor: theme.palette.info.dark, borderStyle: 'solid' })}>
          You have not scheduled a challenging / meaningful activity yet. Please schedule a challenging / meaningful activity to improve your well-being.
        </Alert>
      )}
      <Typography variant="subtitle1" gutterBottom>
        {' '}
        Pick topic area and select an activity for the week
      </Typography>
      <Stack spacing={2}>
        {data?.userDomains.map((domain) => (
          <DomainListItem
            domain={domain}
            key={domain._id}
            onClick={(domain) => {
              const newInput = { domainID: domain._id } as Partial<ActivityInput>;
              onNext(newInput, domain);
            }}
          />
        ))}
      </Stack>
    </>
  );
};
